import { IGfpaFactorContribution } from '@/interfaces/gfpaReport.interface'
import { reportDefaultColDef } from '@/utils/grid-utils/colDefs'
import {
  ColDef,
  ColGroupDef,
  GridReadyEvent,
  ModuleRegistry,
} from '@ag-grid-community/core'
import { CsvExportModule } from '@ag-grid-community/csv-export'
import { AgGridReact } from '@ag-grid-community/react'
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export'
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping'
import { sideBarDefaultConfig } from '@utils/grid-utils/ag-grid-config'
import React, { useMemo, useRef } from 'react'

export type IGfpaFactorContributionProps = {
  rowData: IGfpaFactorContribution[]
  setGridReference: Function
  columnsList: (ColDef | ColGroupDef)[]
}

ModuleRegistry.registerModules([
  CsvExportModule,
  ExcelExportModule,
  RowGroupingModule,
])
export const GFPAFactorContributionTable: React.FC<
  IGfpaFactorContributionProps
> = ({ rowData, setGridReference, columnsList }) => {
  const themeClassName = 'ag-theme-quartz'
  const gridRef = useRef<AgGridReact>(null)

  const onGridReady = (params: GridReadyEvent) => {
    params.api.sizeColumnsToFit()
    setGridReference(gridRef)
  }

  const autoGroupColumnDef = useMemo<ColDef>(() => {
    return {
      ...reportDefaultColDef,
      headerTooltip: 'Factor',
      headerName: 'Factor',
      minWidth: 190,
      tooltipValueGetter: (params) => {
        if (params.node?.group && params.node.level !== -1) {
          const count = params.node.allChildrenCount
          const groupFieldValue = params.node.key
          const displayGroupName = `${groupFieldValue} (${count})`
          return displayGroupName
        }
        return params.value
      },
    }
  }, [])

  return (
    <div
      className={`${themeClassName}`}
      style={{ boxSizing: 'border-box', paddingBottom: '2rem', height: '100%' }}
    >
      <AgGridReact
        groupAllowUnbalanced
        ref={gridRef}
        onGridReady={onGridReady}
        columnDefs={columnsList}
        rowData={rowData}
        autoGroupColumnDef={autoGroupColumnDef}
        sideBar={sideBarDefaultConfig}
        groupDefaultExpanded={1}
        data-cy='gfpa-factor-contribution'
        suppressAggFuncInHeader={true}
      ></AgGridReact>
    </div>
  )
}
